module.exports = __webpack_public_path__ + "img/face.3a39bd2a.svg";